// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loader_spinner__1BGHY","sk-bouncedelay":"Loader_sk-bouncedelay__3GllZ","bounce1":"Loader_bounce1__1tn9b","bounce2":"Loader_bounce2__nY-iW"};